import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled } from '@mui/material/styles';
import AudioPlayer from 'react-h5-audio-player';
const AudioPlayerStyled = styled(AudioPlayer)(({ theme }) => ({
    boxShadow: 'none',
    borderBottomRightRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: theme.shape.borderRadius,
}));
const CustomizedAudioPlayer = ({ url, onProgress, playerStyle, seekPosition, onEnd, handleNextPrevious, }) => {
    const playerRef = React.useRef(null);
    const handleOnReady = (e) => {
        if (seekPosition && seekPosition > 0 && e?.srcElement) {
            e.srcElement.currentTime = seekPosition;
        }
    };
    const handleProgress = (e) => {
        // if (!seeking) {
        // setProgress(state);
        if (onProgress) {
            // @ts-ignore
            onProgress(e?.srcElement?.currentTime);
        }
        // }
    };
    React.useEffect(() => {
        // @ts-ignore
        if (seekPosition && seekPosition > 0 && playerRef?.current?.audio?.current?.currentTime) {
            // @ts-ignore
            playerRef.current.audio.current.currentTime = seekPosition;
        }
    }, [seekPosition]);
    return (_jsx(AudioPlayerStyled, { ref: playerRef, src: url, showSkipControls: true, showJumpControls: false, style: playerStyle, onLoadedMetaData: handleOnReady, listenInterval: 1000, onClickNext: () => handleNextPrevious('next'), onClickPrevious: () => handleNextPrevious('previous'), onListen: handleProgress, onEnded: onEnd }));
};
CustomizedAudioPlayer.defaultProps = {
    playerStyle: {},
    seekPosition: null,
    onProgress: null,
    onEnd: null,
};
export default CustomizedAudioPlayer;
//# sourceMappingURL=AudioPlayer.js.map